<div class="modal-header">
    <h4 class="modal-title">{{ "international_projects.visits.achievement" | translate }}</h4>
    <button type="button" class="btn-close" aria-label="Close button" aria-describedby="modal-title" (click)="modal.close()"></button>
</div>
<div class="modal-body" [formGroup]="model">
    <div class="row">
        <div class="col-12">
            <adaa-form-input
                controlName="textAE"
                formControlName="textAE"
                [required]="true"
                [isTextArea]="true"
                [invalid]="submitted && model.get('textAE')?.invalid!"
                [label]="'international_projects.visits.achievement_ae' | translate"
            />
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <adaa-form-input
                controlName="textEN"
                formControlName="textEN"
                [required]="true"
                [isTextArea]="true"
                [invalid]="submitted && model.get('textEN')?.invalid!"
                [label]="'international_projects.visits.achievement_en' | translate"
            />
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close()">{{ "common.form.button.close" | translate }}</button>
    @if (!isViewMode()) {
        <button type="button" class="btn btn-primary" (click)="save()">{{ "common.form.button.save" | translate }}</button>
    }
</div>
